import { Component, DOCUMENT, inject } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { StaleBuildReloader } from '@seiri/shared/frontend'
import { PageMessageComponent } from '../page-message/page-message.component'

/**
 * What a fresh page shows when its first route could not load its chunk (docs/web-releases.md). Loaded eagerly, since
 * a lazy chunk is what failed. The address bar keeps the visitor's link, so "Skúsiť znova" reloads straight into it.
 */
@Component({
  selector: 'seiri-load-failed',
  imports: [MatButton, PageMessageComponent],
  template: `
    <!-- While the reload is under way the page is about to be replaced, so there is nothing to say. -->
    @if (!reloading) {
      <seiri-page-message heading="Stránku sa nepodarilo načítať" text="Skúste to, prosím, znova o chvíľu.">
        <button type="button" matButton="filled" (click)="retry()">Skúsiť znova</button>
      </seiri-page-message>
    }
  `,
})
export class LoadFailedComponent {
  private readonly document = inject(DOCUMENT)

  protected readonly reloading = inject(StaleBuildReloader).isReloading()

  protected retry(): void {
    this.document.defaultView?.location.reload()
  }
}
